import React from 'react'
import './Splash.page.css'
import { IonImg } from '@ionic/react'

import { useHistory } from 'react-router-dom'
import { AppRouterConstants } from '../../../components/appRouter/AppRouter.constants'

type SplashImage = {
  src: string
  altText: string
}

const logo: SplashImage = {
  src: '/assets/images/zoll-logo-white.png',
  altText: 'Zoll Logo',
}

const Splash: React.FC = (): JSX.Element => {
  const history = useHistory()

  setTimeout(() => RenderLogin(), 3000)

  const RenderLogin = () => {
    history.push(AppRouterConstants.LOGIN_ROUTE)
  }

  return (
    <div className='splash-screen'>
      <IonImg class='zoll-splash-logo' src={logo.src} />
    </div>
  )
}

export default Splash
